import { Component, ViewChild, ElementRef } from '@angular/core';
import { IonicPage, NavController, NavParams, MenuController, ModalController } from 'ionic-angular';
import { Chart } from "chart.js";
import { DashboardPage } from '../dashboard/dashboard';
import { DashboardProvider } from '../../../providers/dashboard/dashboard';


@IonicPage()
@Component({
  selector: 'rh-employer',
  templateUrl: 'rh.html',
})
export class RhEmployerPage {
  // @ViewChild("pieHF") pieHF: ElementRef;
  // private pieHFChart: Chart;

  historyMode:boolean = false;
  rhStats:any = {
    totalEmployees : 0,
    females : 0,
    males : 0,
    averageAge : 0,
  };

  constructor(public navCtrl: NavController, public navParams: NavParams, menu: MenuController, public modalCtrl: ModalController, public dashboardProvider: DashboardProvider) {
    menu.enable(true);
  }

  ionViewDidLoad() {

  }


  ngOnInit() {

    this.fetchRhStats();
    this.generateChart()
   
  }

  fetchRhStats(){
    this.dashboardProvider.rhStats().subscribe((res) => {
      if(res.success){
        this.rhStats = res.data;
      }
    })
  }

  generateChart() {
    // this.pieHFChart = new Chart(this.pieHF.nativeElement, {
    //   type: "horizontalBar",
    //   data: {
    //     labels: ["Analyste", "Dîplomate", "Explorateur", "Sentinel"],
    //     datasets: [
    //       {
    //         label: "Type de personnalité",
    //         fill: false,
    //         lineTension: 0.1,
    //         borderColor: "rgba(75,192,192,1)",
    //         borderCapStyle: "butt",
    //         borderDash: [],
    //         backgroundColor: ["#DBEAF1", "#AED3E5","#2787B7","#035D8F","#024669", "#024669", "#AED3E5"],
    //         borderDashOffset: 0.0,
    //         borderJoinStyle: "miter",
    //         pointBorderColor: "rgba(75,192,192,1)",
    //         pointBackgroundColor: "#fff",
    //         pointBorderWidth: 1,
    //         pointHoverRadius: 5,
    //         pointHoverBackgroundColor: "rgba(75,192,192,1)",
    //         pointHoverBorderColor: "rgba(220,220,220,1)",
    //         pointHoverBorderWidth: 2,
    //         pointRadius: 1,
    //         pointHitRadius: 10,
    //         data: [8, 2, 4, 7],
    //         spanGaps: false
    //       }
    //     ]
    //   },
    //   options: {
    //     scales: {
    //       xAxes: [{
    //           ticks: {
    //               beginAtZero: true
    //           }
    //       }]
    //   },
    //     legend: {
    //       display: false,
    //     },
    //     tooltips: {
    //       displayColors: false,
    //       callbacks: {
    //         title: function(tooltipItems, data) {
    //           return;
    //         },
    //         label: function(tooltipItem, data) {
    //           var datasetLabel = '';
    //           var label = data.labels[tooltipItem.index];
    //           return;
    //         }
    //       }
    //     },
    //     tooltipTemplate: "<%= value %>",
    //     onAnimationComplete: function () {
    //         this.showTooltip(this.datasets[0].bars);
    //     },

    //     tooltipEvents: [],

    //     showAllTooltips: false,
    //     responsive: true,
    //   }
    // });
  }

}





// WEBPACK FOOTER //
// ./src/pages/employer/rh/rh.ts